const message = document.querySelector('.cm-free-shipping-progress__message');

const freeShippingThreshold = message ? Number(message.dataset.freeShippingThreshold) : null;

const updateFreeShippingMessage = () => {
  const totalValue = document.querySelector('.totals__total-value');
  const message = document.querySelector('.cm-free-shipping-progress__message');

  if (!totalValue || !message || !freeShippingThreshold) return;

  const total = Number(totalValue.textContent.replace(/[^\d]/g, ''));

  let newText;

  if (total >= freeShippingThreshold) {
    newText = message.dataset.qualifiedMessage;
  } else {
    const remaining = freeShippingThreshold - total;
    newText = `送料無料まであと${remaining.toLocaleString()}円です。`;
  }

  if (message.textContent.trim() !== newText) {
    message.textContent = newText;
  }
};

const cartBlocks = document.querySelector('.cart__blocks');

if (cartBlocks) {
  const observer = new MutationObserver((mutations) => {
    const totalChanged = mutations.some((mutation) => {
      const target = mutation.target;

      if (target.nodeType === Node.ELEMENT_NODE && target.matches('.totals__total-value, .totals__total-value *')) {
        return true;
      }

      if (target.nodeType === Node.TEXT_NODE && target.parentElement?.closest('.totals__total-value')) {
        return true;
      }

      return [...mutation.addedNodes].some((node) => {
        return node.nodeType === Node.ELEMENT_NODE && (node.matches('.totals__total-value') || node.querySelector('.totals__total-value'));
      });
    });

    if (totalChanged) {
      updateFreeShippingMessage();
    }
  });

  observer.observe(cartBlocks, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

updateFreeShippingMessage();
